module.exports = __webpack_public_path__ + "static/img/game4.d6621f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game4.jpg
// module id = mThr
// module chunks = 1